/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ChangeRequestArchive({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M1.4 3.5c0 1.23.853 2.26 2 2.53v3.94a2.601 2.601 0 1 0 1.2 0V6.03A2.601 2.601 0 1 0 1.4 3.5Zm1.2 0a1.4 1.4 0 1 0 2.8 0 1.4 1.4 0 0 0-2.8 0Zm0 9a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0ZM9.4 3.5c0 1.23.853 2.26 2 2.53v7.022l-1.976-1.976a.6.6 0 1 0-.848.848l3 3a.6.6 0 0 0 .848 0l3-3a.6.6 0 1 0-.848-.848L12.6 13.052V6.03A2.601 2.601 0 1 0 9.4 3.5Zm1.2 0a1.4 1.4 0 1 0 2.8 0 1.4 1.4 0 0 0-2.8 0Z" clipRule="evenodd" /></svg>;
}
;